import TimeDiagram from './TimeDiagram'

export default TimeDiagram